import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'results']

  connect() {
    this.selectedIndex = -1
    this.debounceTimer = null
    this.results = []

    this.inputTarget.addEventListener('input', this.onInput.bind(this))
    this.inputTarget.addEventListener('keydown', this.onKeydown.bind(this))
    document.addEventListener('click', this.onClickOutside.bind(this))
  }

  disconnect() {
    document.removeEventListener('click', this.onClickOutside.bind(this))
    if (this.debounceTimer) clearTimeout(this.debounceTimer)
  }

  onInput() {
    const query = this.inputTarget.value.trim()
    if (query.length < 2) {
      this.hideResults()
      return
    }

    if (this.debounceTimer) clearTimeout(this.debounceTimer)
    this.debounceTimer = setTimeout(() => this.fetchPredictions(query), 300)
  }

  onKeydown(event) {
    if (!this.results.length) return

    switch (event.key) {
      case 'ArrowDown':
        event.preventDefault()
        this.selectedIndex = Math.min(this.selectedIndex + 1, this.results.length - 1)
        this.highlightResult()
        break
      case 'ArrowUp':
        event.preventDefault()
        this.selectedIndex = Math.max(this.selectedIndex - 1, 0)
        this.highlightResult()
        break
      case 'Enter':
        if (this.selectedIndex >= 0) {
          event.preventDefault()
          this.selectResult(this.results[this.selectedIndex])
        }
        break
      case 'Escape':
        this.hideResults()
        break
    }
  }

  async fetchPredictions(query) {
    try {
      const response = await fetch(`/admin/gym_import/autocomplete?query=${encodeURIComponent(query)}`)

      if (!response.ok) return

      const data = await response.json()
      this.results = data.predictions || []
      this.selectedIndex = -1
      this.showResults()
    } catch (error) {
      console.error('[PlacesAutocomplete] Error:', error)
    }
  }

  showResults() {
    if (!this.results.length) {
      this.hideResults()
      return
    }

    const html = this.results.map((prediction, index) => `
      <div class="px-3 py-2 text-sm cursor-pointer hover:bg-slate-100 transition-colors ${index === this.selectedIndex ? 'bg-slate-100' : ''}"
           data-index="${index}"
           data-action="click->admin--places-autocomplete#pickResult">
        <span class="text-slate-900">${prediction.description}</span>
      </div>
    `).join('')

    this.resultsTarget.innerHTML = html
    this.resultsTarget.classList.remove('hidden')
  }

  hideResults() {
    this.results = []
    this.selectedIndex = -1
    this.resultsTarget.classList.add('hidden')
    this.resultsTarget.innerHTML = ''
  }

  highlightResult() {
    const items = this.resultsTarget.querySelectorAll('[data-index]')
    items.forEach((item, i) => {
      item.classList.toggle('bg-slate-100', i === this.selectedIndex)
    })
  }

  pickResult(event) {
    const index = parseInt(event.currentTarget.dataset.index, 10)
    if (this.results[index]) {
      this.selectResult(this.results[index])
    }
  }

  selectResult(prediction) {
    this.inputTarget.value = prediction.description
    this.hideResults()
  }

  onClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.hideResults()
    }
  }
}
